import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from './plugin'
import { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig<
  TTypeParams extends ec.models.TypeParams.Constraint,
>(collection: ec.Collection<TTypeParams>) {
  return {
    /* eslint-disable sort-keys */
    /** TODO:  */
    startEditingCustomLabel: store.actions.standalone({
      data: ({
        selectionTarget = ec.models.Target.DEFAULT,
      }: {
        readonly selectionTarget?: ec.models.Target
      } = {}) => ({
        selectionTarget,
      }),
    }),
    /** TODO:  */
    editCustomLabel: store.actions.standalone({
      data: ({
        label,
        selectionTarget = ec.models.Target.DEFAULT,
      }: {
        readonly selectionTarget?: ec.models.Target
        readonly label?: string
      } = {}) => ({
        label,
        selectionTarget,
      }),
      reducerDeprecated: (state, action) => ({
        ...state,
        editingCustomLabel: action,
      }),
    }),
    /**
     * TODO:
     */
    submitCustomLabel: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        success: ({ state }) => ({
          ...state,
          editingCustomLabel: undefined,
        }),
        error: ({ state }) => ({
          ...state,
          editingCustomLabel: undefined,
        }),
      },
    }),
    /** TODO:  */
    discardCustomLabel: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => ({
        ...state,
        editingCustomLabel: undefined,
      }),
    }),

    /**
     * TODO:
     */
    referenceEntity: store.actions.standalone({
      data: ({
        id,
        referencerSelectionTarget = ec.models.Target.DEFAULT,
      }: {
        /** The {@link ec.models.EntityId} that is being referenced. */
        // This is associated entity id
        readonly id: ec.models.EntityId
        /** @see {@link ec.plugins.standard.association.models.Selection.Target} */
        // base entity id and additional details e.g. rule-1 (idx 1)
        readonly referencerSelectionTarget?: ec.models.Target
      }) => ({
        id,
        referencerSelectionTarget,
      }),
      reducerDeprecated: (state, action) =>
        State.referenceEntityIds(
          state,
          action.referencerSelectionTarget,
          action.id,
        ),
    }),
    /**
     * TODO:
     */
    dereferenceEntity: store.actions.standalone({
      data: ({
        id,
        referencerSelectionTarget,
        referencerSelectionTargetPredicate,
      }: {
        /**
         * The {@link ec.models.EntityId} that is being dereferenced.
         *
         * If this is `undefined`, then all entities will be dereferenced.
         *
         * @default undefined
         */
        // This is associated entity id
        readonly id?: ec.models.EntityId
      } & ExactlyOneOf<{
        /** @see {@link ec.plugins.standard.association.models.Selection.Target} */
        // base entity id and additional details e.g. rule-1 (idx 1)
        readonly referencerSelectionTarget: ec.models.Target
        /** @see {@link ec.plugins.standard.association.models.Selection.Target} */
        // base entity id and additional details e.g. rule-1 (idx 1)
        readonly referencerSelectionTargetPredicate: (
          target: ec.models.Target,
        ) => boolean
      }>) => ({
        id,
        referencerSelectionTarget,
        referencerSelectionTargetPredicate,
      }),
      reducerDeprecated: (state, action) => {
        if (action.referencerSelectionTarget) {
          const entityIds = action.id
            ? [action.id]
            : State.getReferencedEntityIds(
                state,
                action.referencerSelectionTarget,
              )

          state = State.dereferenceEntityIds(
            state,
            action.referencerSelectionTarget,
            ...entityIds,
          )

          return state
        } else {
          // TODO: Implement this case.
          throw new Error('TODO: work on this case')
        }
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
